import React, { useState } from "react";
import UseCaseHeader from "components/UseCaseHeader";
import ContactlessCard from "components/ContactlessCard";
import { USE_CASES } from "utils/constants/useCases";
import InfoNotice from "components/InfoNotice";
import { CONTACTLESS_SERVICES } from "utils/constants/useCases";
import ServiceIconGrid from "components/ServiceIconGrid";
import Toggle from "react-toggle";
import { getToggleProps } from "utils/form";
import { useCardMaxWidth } from "utils/hooks";
import { DEFAULT_CONTACTLESS_IMG } from "constants/contactless";

const COPY_PRIMARY =
  "Contactless payment is the new normal for in person transactions and it's usage is expected to triple by 2024.";
const COPY_SECONDARY =
  "Payment links have a unique QR code to automatically enable contactless payments without the need for expensive POS hardware. Your customers simply scan with their smartphone, pay and they're done.";

const Contactless = ({ shortLink, loading }) => {
  const [contactless, setContactless] = useState(true);
  const compatibleWith = (
    <div className="w-100 pt3">
      <div className="f6 black-50 pb2 pb0-l">Compatible with</div>
      <ServiceIconGrid services={Object.values(CONTACTLESS_SERVICES)} />
    </div>
  );
  const cardMaxWidth = useCardMaxWidth();

  const contactlessProps = {
    shortLink,
    contactless,
    test: true,
    code: {
      image: DEFAULT_CONTACTLESS_IMG
    }
  };

  return (
    <section className="w-100 flex flex-column flex-row-ns">
      <div key="contactless-content" className="w-100 fl pr4">
        <UseCaseHeader type={USE_CASES.CONTACTLESS} />
        <div className="f5 f4-l fw4 mb3 mt0-ns tl lh-copy pt2 pt4-l">
          {COPY_PRIMARY}
          <sup className="f7">[6]</sup>
        </div>
        <div className="dn dib-ns">
          <div className="f5 f4-l fw4 mb3 mt0-ns tl lh-copy pt2 dn dib-ns">
            {COPY_SECONDARY}
          </div>
          {compatibleWith}
        </div>
      </div>
      <div
        style={{ maxWidth: cardMaxWidth }}
        key="contactless-card"
        className="w-100 fr"
      >
        <div className="w-100 center pb3">
          <div className="flex flex-column ba br2 items-start hairline-1 pa3 black-80 bg-white db">
            <div className="flex flex-row justify-between items-center w-100">
              <div className="f5 fw6">Go contactless</div>
              <Toggle
                {...getToggleProps({
                  active: contactless,
                  setFieldValue: (_, active) => {
                    setContactless(active);
                  }
                })}
              />
            </div>
            <div className="f6 lh-copy pt1">
              Toggle between contactless and standard display.
            </div>
          </div>
        </div>
        {shortLink && !loading && (
          <ContactlessCard {...contactlessProps}>
            {contactless ? (
              <div className="pt3">
                <InfoNotice
                  icon="scan"
                  copy="Scan with your phone to test checkout."
                />
              </div>
            ) : null}
          </ContactlessCard>
        )}
        <div className="w-100 dn-ns dib pt2 pt0-ns">
          <div className="f5 f4-l fw4 mb3 mt0-ns tl lh-copy pt2">
            {COPY_SECONDARY}
          </div>
          {compatibleWith}
        </div>
      </div>
    </section>
  );
};

export default Contactless;
